export const SectionDivider = ({ title, subtitle }: { title: string; subtitle?: string }) => {
  return (
    <div className="px-4 md:px-12 lg:px-36 mx-auto px-4 w-full text-center mb-8">
      <div className="w-full flex items-center justify-center">
        <div className="h-[2px] w-full bg-green-500 dark:bg-green-300 w-[20vh] rounded" />
        <h2 className="text-3xl font-bold mb-4 text-center whitespace-nowrap mx-12">{title}</h2>
        <div className="h-[2px] w-full bg-green-500 dark:bg-green-300 w-[20vh] rounded" />
      </div>
      {subtitle && <p className="text-gray-500 mt-2">{subtitle}</p>}
    </div>
  )
}
